import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =`<template>
    <style>
        :host {
            display: block;
            padding: 15px 0;
            --primary-active: #253B56;
            --icon-available: #008900;
            --icon-unavailable: #DD3700;
        }

        com-html#title {
            font-size: var(--type20_-_font-size);
        }

        com-html#title .selectedDate {
            font-family: var(--font-family-heavy);
        }

        :host([adaptive='xs']) com-html#title .selectedDate {
            display: block;
        }

        :host #parkAvailabilityContainer {
            padding-top: 5px;
            max-width: 590px;
        }

        :host #parkAvailabilityContainer > div {
            width: calc(50% - 20px);
            padding: 10px 0 10px;
            display: inline-block;
        }

        :host([adaptive='xs']) #parkAvailabilityContainer > div {
            display: block;
            width: calc(100% - 20px);
        }

        :host #parkAvailabilityContainer .available com-icon {
            color: var(--icon-available);
        }

        :host #parkAvailabilityContainer .unavailable com-icon {
            color: var(--icon-unavailable);
        }

        :host #parkAvailabilityContainer > div span {
            font-size: var(--type16_-_font-size);
            position: relative;
            top: -2px;
            left: 10px;
        }

        :host #disclaimer {
            display: block;
            color: #607682;
            margin-top: 30px;
            max-width: 740px;
            font-size: var(--type14_-_font-size);
            line-height: var(--font14-line-height);
        }
    </style>
</template>`;

styleElement.register('com-avl-cal-awakening-information-style');